<template>
  <nut-popup v-model="show" @input="input" closeable :style="{width:'85%',borderRadius:'7px',paddingBottom: '15px'}">
    <div
      style="height: 40px;line-height: 40px;padding: 0 10px;font-size:14px;text-align: center;border-bottom: 1px solid #F5F6F8;">
      支付信息
    </div>
    <div style="height: 40px;line-height: 40px;display: flex;align-items: center;justify-content: space-between;">
      <span style="margin-left: 15px;">金额</span>
      <nut-price style="margin-right: 15px;" :price="price" :decimalDigits="2" :needSymbol="true" :thousands="true"/>
    </div>
    <div class="line"></div>
    <div style="height: 40px;line-height: 40px;display: flex;align-items: center;justify-content: space-between;">
      <span style="margin-left: 15px;">应付</span>
      <nut-price style="margin-right: 15px;color: #ff2206;zoom: 1.2;" :price="price" :decimalDigits="2"
                 :needSymbol="true" :thousands="true"/>
    </div>
    <div class="line"></div>
    <div v-if="webType == 'alipay'" @click="type = -1"
         style="height: 40px;line-height: 40px;display: flex;align-items: center;justify-content: space-between;">
      <div style="display: flex;align-items: center;margin-left: 10px;">
        <img :src="require('../../../../resource/img/device/svg/alipay_fang.svg')"
             style="width: 30px;height: 30px; margin-right: 10px;">
        <span>支付宝支付</span>
      </div>
      <nut-radio size="small" v-model="type" :label="-1"></nut-radio>
    </div>
    <div v-if="webType == 'weixin'" @click="type = 0"
         style="height: 40px;line-height: 40px;display: flex;align-items: center;justify-content: space-between;">
      <div style="display: flex;align-items: center;margin-left: 10px;">
        <img :src="require('../../../../resource/img/device/svg/weixin_fang.svg')" style="width: 40px;height: 40px;">
        <span>微信支付</span>
      </div>
      <nut-radio size="small" v-model="type" :label="0"></nut-radio>
    </div>
    <div v-if="showBalance" @click="type = 1"
         style="height: 40px;line-height: 40px;display: flex;align-items: center;justify-content: space-between;">
      <div style="display: flex;align-items: center;margin-left: 10px;">
        <img :src="require('../../../../resource/img/device/svg/balance_pay.svg')"
             style="width: 25px;height: 25px;margin-left: 3px; margin-right:12px;">
        <span>余额支付</span>
        <span style="margin-left: 10px;color: #8e8e8e">余额:{{cardMoney}}元</span>
      </div>
      <nut-radio size="small" v-model="type" :label="1"></nut-radio>
    </div>
    <div v-if="showCard" @click="type = 2"
         style="height: 40px;line-height: 40px;display: flex;align-items: center;justify-content: space-between;">
      <div style="display: flex;align-items: center;margin-left: 10px;">
        <img :src="require('../../../../resource/img/device/year_icon.png')"
             style="width: 25px;height: 25px;margin-left: 3px; margin-right:12px;">
        <span>年卡支付</span>
      </div>
      <nut-radio size="small" v-model="type" :label="2"></nut-radio>
    </div>
    <div style="text-align: center;margin-top: 20px;">
      <nut-button style="border-radius: 7px;width: 90%;background: #00c250;" @click="pay">立即支付</nut-button>
    </div>
  </nut-popup>
</template>

<script>
/**
 * 支付弹窗
 */
export default {
  name: 'Pay',
  model: {
    prop: 'value',//指向props的参数名
    event: 'input'//事件名称
  },
  props: {
    //是否显示弹窗
    value: {
      type: Boolean,
      default: false
    },
    //金额
    price: {
      type: Number,
      default: 0.00
    },
    //应付金额
    payPrice: {
      type: Number,
      default: 0.00
    },
    //支付类型
    payType: {
      type: Number,
      default: 1
    },
    //用户余额
    cardMoney: {
      type: Number,
      default: 0.00
    },
    /**
     * 自定义参数
     */
    data: {
      type: Object,
      default: {}
    },
    //是否显示余额支付
    showBalance: {
      type: Boolean,
      default: true
    },
    //是否显示年卡支付
    showCard: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      //是否显示
      show: false,
      //支付类型 0.微信支付
      type: 0,
      //是否锁定按钮不可重复点击
      disabled: false,
      //网页类型
      webType: '',
    }
  },
  created () {
    this.show = this.value
    this.webType = localStorage.getItem('webType')
    if (this.webType == 'weixin') {
      this.type = 0
    } else {
      this.type = -1
    }
    this.addressName = localStorage.getItem('addressName')
  },
  watch: {
    value (val) {
      this.show = val
    }
  },
  methods: {
    input (val) {
      this.$emit('input', val)
    },
    //支付
    pay () {
      if (this.disabled) {
        return
      }
      this.disabled = true
      //设备启动支付
      if (this.payType == 1) {
        this.$api.post({
          url: '/device/api/device/order/add',
          data: {
            agentId: this.data.agentId,
            merId: this.data.merId,
            uid: this.data.uid,
            payMoney: this.payPrice,
            totalMoney: this.price,
            serviceId: this.data.serviceId,
            deviceId: this.data.deviceId,
            orderType: 1,
            pay: this.type
          }
        }).then(res => {
          if (this.type == 1 || this.type == 2) { //余额支付or年卡支付
            let loadingComponent = this.$toast.loading('确认支付结果中...', {
              coverColor: 'rgba(0,0,0,0.5)'
            })
            if (res.data.paid == 1) {
              loadingComponent.hide()
              let data = {
                payType: this.payType,
                orderId: res.data.orderId
              }
              this.$router.push({
                path: '/device/PayOk',
                query: {
                  data: encodeURIComponent(JSON.stringify(data))
                }
              })
            }
          } else { //第三方支付
            if (this.type == 0) {//微信支付
              let order = res.data
              order.url = '/device/api/device/order/is-pay'
              order.data = {
                orderId: order.orderId
              }
              //调取微信支付接口
              this.$api.wxPay(order).then(res => {
                let data = {
                  payType: this.payType,
                  orderId: order.orderId
                }
                this.$router.push({
                  path: '/device/PayOk',
                  query: {
                    data: encodeURIComponent(JSON.stringify(data))
                  }
                })
              }).catch(() => {
                this.disabled = false
              })
            }
            if (this.type == -1) { //支付宝支付
              const div = document.createElement('div')
              /* 此处form就是后台返回接收到的数据 */
              div.innerHTML = res.data
              document.body.appendChild(div)
              document.forms[0].submit()
            }
          }
        }).catch(() => {
          this.disabled = false
        })
      }
      //设备充值支付
      if (this.payType == 2) {
        if (this.$util.isArrOrNull(this.data.orderId)) { //新订单
          this.$api.post({
            url: '/device/api/device/device-recharge-order/save',
            data: {
              agentId: this.data.agentId,
              merId: this.data.merId,
              uid: this.data.uid,
              deviceId : this.data.deviceId,
              money: this.data.money,
              giveMoney: this.data.giveMoney,
              pay: this.type
            }
          }).then(res => {
            if (this.type == -1) { //支付宝支付
              const div = document.createElement('div')
              /* 此处form就是后台返回接收到的数据 */
              div.innerHTML = res.data
              document.body.appendChild(div)
              document.forms[0].submit()
            }
            if (this.type == 0) { //微信支付
              let order = res.data
              order.url = '/device/api/device/device-recharge-order/is-pay'
              order.data = {
                orderId: order.orderId
              }
              //调取微信支付接口
              this.$api.wxPay(order).then(res => {
                let data = {
                  payType: this.payType,
                }
                this.$router.push({
                  path: '/device/PayOk',
                  query: {
                    data: encodeURIComponent(JSON.stringify(data))
                  }
                })
              }).catch(() => {
                this.disabled = false
              })
            }
          }).catch(() => {
            this.$router.push({
              path: '/device/DeviceRechargeRecord',
            })
            this.disabled = false
          })
        } else { //支付已有订单
          if (this.type == -1) { //支付宝支付
            this.$api.post({
              url: '/device/api/device/device-recharge-order/ali/pay',
              data: this.data
            }).then(res => {
              const div = document.createElement('div')
              /* 此处form就是后台返回接收到的数据 */
              div.innerHTML = res.data
              document.body.appendChild(div)
              document.forms[0].submit()
            }).catch(() => {
              this.disabled = false
            })
          }
          if (this.type == 0) {//微信支付
            this.$api.post({
              url: '/device/api/device/device-recharge-order/wx/pay',
              data: this.data
            }).then(res => {
              let order = res.data
              order.url = '/device/api/device/device-recharge-order/is-pay'
              order.data = {
                orderId: order.orderId
              }
              //调取微信支付接口
              this.$api.wxPay(order).then(res => {
                let data = {
                  payType: this.payType,
                }
                this.$router.push({
                  path: '/device/PayOk',
                  query: {
                    data: encodeURIComponent(JSON.stringify(data))
                  }
                })
              }).catch(() => {
                this.disabled = false
              })
            }).catch(() => {
              this.disabled = false
            })
          }
        }
      }
      //开通年卡支付
      if (this.payType == 3) {
        this.$api.post({
          url: '/device/api/device/device-card-order/save',
          data: {
            agentId: this.data.agentId,
            merId: this.data.merId,
            uid: this.data.uid,
            cardId: this.data.cardId,
            totalMoney: this.data.money,
            pay: this.type,
          }
        }).then(res => {
          if (this.type == -1) {//支付宝支付
            const div = document.createElement('div')
            /* 此处form就是后台返回接收到的数据 */
            div.innerHTML = res.data
            document.body.appendChild(div)
            document.forms[0].submit()
          }
          if (this.type == 0) { //微信支付
            let order = res.data
            order.url = '/device/api/device/device-card-order/is-pay'
            order.data = {
              orderId: order.orderId
            }
            //调取微信支付接口
            this.$api.wxPay(order).then(res => {
              let data = {
                payType: this.payType,
              }
              this.$router.push({
                path: '/device/PayOk',
                query: {
                  data: encodeURIComponent(JSON.stringify(data))
                }
              })
            }).catch(() => {
              this.disabled = false
            })
          }
        }).catch(() => {
          this.disabled = false
        })
      }
    }
  }
}
</script>

<style scoped>
  >>> .nut-radio input:checked {
    background-color: #6bc839;
    border-color: #6bc839;
    box-shadow: 0 4px 6px 0 rgba(26, 250, 41, .15);
  }

  >>> .nut-radio input:after {
    background: #6bc839;
  }

  .line {
    height: 1px;
    margin: 0 10px;
    background-color: #F5F6F8;
  }
</style>



// WEBPACK FOOTER //
// src/components/device/common/Pay/Pay.vue